export enum FormStatus {
    "INIT_REGISTER",
    "INIT_UPLOAD",
    "SUCCESS",
    "ERROR",
    "INVALID",
    "LOADING",
}
